import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseTypeForm from '../../../components/forms/ExerciseTypeForm';
import { useExerciseTypeApi } from '../../../hooks/useExerciseTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseTypeDTO } from '../../../services/apiClient';

const ExerciseTypeCreate: React.FC = () => {
  const { create, isLoading } = useExerciseTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Types', href: '/admin/exercisetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ExerciseTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/exercisetypes');
    } catch (error) {
      console.error('Error creating Exercise Type:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseType.Edit'
    >
        <ExerciseTypeForm
          initialValues={{} as ExerciseTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/exercisetypes')}
        />
    </AdminLayout>
  );
};

export default ExerciseTypeCreate;